import React, { Fragment } from 'react'
import { Box } from 'stylist'
import withFeature from 'components/withFeature'
import InfoGroup from 'components/InfoGroup'
import Subheader from 'components/Subheader'
import renderValue from 'utils/renderValue'
import fields from 'fields/features'

const RouteShow = ({ feature }) => (
  <Fragment>
    <h5>Feature Information</h5>
    <Box>
      <Box.Item pad>
        {fields.map(field => (
          <InfoGroup key={field.name}>
            <Subheader>{field.label || field.name}:</Subheader>
            <span>{renderValue(feature[field.name])}</span>
          </InfoGroup>
        ))}
      </Box.Item>
    </Box>
  </Fragment>
)

export default withFeature(RouteShow)



// WEBPACK FOOTER //
// ./src/routes/admin/features/show.js